<template>
<div class="option">
    <label :for="nameSlug" class="dropdown-label">{{ productOption.name }}</label>
    <v-select
        :id="nameSlug"
        v-model="selected" class="option-select" :clearable="false"
        :searchable="false"
        :options="productOption.values"
        v-on:update:model-value="handleChange"
    >
        <template v-slot:open-indicator="{ attributes }">
            <span v-bind="attributes">
                <NuxtImg alt="" src="/images/icons/platforms/down-arrow.png" width="16" height="16" />
            </span>
        </template>
    </v-select>
</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import Shopify from '@jackboxgames/shopify'

export default defineComponent({
    props: {
        productOption: {
            type: Object as PropType<Shopify.Shopify.ProductOption>,
            required: true
        }
    },
    emits: ['change'],
    data() {
        return {
            selected: <string | null>null
        }
    },
    computed: {
        nameSlug() {
            return this.productOption.name.toLowerCase()
        }
    },
    mounted() {
        this.selected = this.productOption.values[0]
        this.$emit('change', this.productOption.name, this.selected)
    },
    methods: {
        handleChange(val: string) {
            this.$emit('change', this.productOption.name, val)
        }
    }
})
</script>

<style lang="scss" scoped>
.option {
    margin-bottom: 15px;
    .size-select {
        margin-bottom: 17px;
        margin-top: 8px;
        padding: 0px 16px;

        :deep(.vs__open-indicator) {
            height: auto;
            width: 12px;
            margin: 4px 4px 0px -10px;
        }

        :deep(.vs__selected) {
            color: var(--neutral-50);
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
        }

        :deep(.vs__dropdown-menu) {
            color: var(--neutral-50);
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
        }
    }
    .dropdown-label {
        display: block;
        margin-bottom: 6px;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        text-transform: uppercase;
    }
}
</style>
